<template>
  <div>
    <!-- 装箱信息 -->
    <el-dialog :title="$t('message.packingInformation')" :close-on-click-modal="false" :visible.sync="dialogVisible"
      width="1508px" center>
      <div class="content">

        <div class="table">
          <ol>
            <!--  番号-->
            <li class="flex05">
              NO
            </li>
            <!-- 订单编号 -->
            <li class="flex15">{{ $t("message.orderbianhao") }}</li>
            <!--  番号-->
            <li class="flex05">
              {{ $t("message.mash") }}
            </li>
            <!--图片-->
            <li>
              {{ $t("message.picture") }}
            </li>
            <!-- 类型 -->
            <li class="flex15">{{ $t("message.type") }}</li>
            <!-- 商品属性 -->
            <li class="flex15">{{ $t("message.commodityAttribute") }}</li>
            <!--交易号  -->
            <li class="flex15">
              {{ $t("message.transactionNumber") }}
            </li>
            <!-- 装箱数量 -->
            <li>{{ $t("message.packingQuantit") }}</li>

          </ol>


          <ul v-for="(item, index) in boxDetail.list" :key="index">
            <li class="flex05">
              {{ index + 1 }}
            </li>
            <!-- 订单号 -->
            <li class="flex15">
              <div>
                <p>{{ item.order_sn }}</p>
                <p>{{ item.realname }}</p>
              </div>
            </li>
            <!--   番号-->
            <li class="flex05">
              {{ item.sorting }}
            </li>
            <!--照片-->
            <li>
              <div>
                <div class="img">
                  <el-popover placement="right" width="300" trigger="hover">
                    <img :src="item.pic" alt="" style="width: 300px; height: 300px" />
                    <a :href="`https://detail.1688.com/offer/${item.goods_id}.html`" target="_blank" slot="reference">
                      <img :src="item.pic" alt="" style="width: 60px; height: 60px" />
                    </a>
                  </el-popover>
                </div>
              </div>
            </li>
            <!-- 类型 -->
            <li class="flex15">
              <div>
                <p>{{ item.from_platform }}</p>
                <p>{{ $t('message.goodsID') }} :{{ item.goods_id }}</p>
              </div>
            </li>
            <!-- 商品属性 -->
            <li class="flex15">
              <div class="template">
                <el-tooltip placement="bottom">
                  <div slot="content">
                    <div class="row" v-for="(itemDetail, itemIndex) in item.detail_y" :key="itemIndex"
                      style="margin-bottom: 5px">
                      {{ itemDetail.key }}：{{ itemDetail.value }}
                    </div>
                  </div>
                  <div>
                    <div class="row" v-for="(itemDetail, itemIndex) in item.detail_y" :key="itemIndex">
                      {{ itemDetail.key }}：{{ itemDetail.value }}
                    </div>
                  </div>
                </el-tooltip>
              </div>
            </li>
            <!--交易号  -->
            <li class="flex15">
              <div class="template">
                <p v-for="(items, indexs) in item.purchase" :key="indexs">
                  {{ items.purchase_no }}
                </p>
              </div>
            </li>
            <!-- 装箱数量 -->
            <li>{{ item.order_detail_total_box_num }}</li>
          </ul>
        </div>

      </div>
      <span slot="footer" class="dialog-footer">

        <!-- 保存 -->
        <el-button type="primary" @click="dialogVisible = false">{{
          $t("message.confirm")
        }}</el-button>
      </span>

    </el-dialog>
  </div>
</template>
<script>

export default {
  props: {
    box_id: { type: Number }
  },
  data() {
    return {
      dialogVisible: false,
      boxDetail: { list: [] },
    };
  },
  computed: {

  },
  created() { },
  methods: {

  },
  watch: {
    dialogVisible() {
      if (this.dialogVisible) {
        this.$api.inspectionApi.boxDetail({ id: this.box_id }).then(res => {
          this.boxDetail = res.data
          console.log(res);
        })
      }
    },
  }
};
</script>
<style lang='scss' scoped>
.content {
  margin: 0 15px;

  .boxNum {
    font-size: 18px;
    margin-bottom: 10px;
  }

  .table {
    .head {
      line-height: 40px;
      font-size: 18px;
      border-bottom: 1px solid #dedede;
    }

    .template {
      width: 100%;
      text-align: left;
    }

    .flex05 {
      flex: 0.5;
    }

    .flex15 {
      flex: 1.5;
    }

    .flex2 {
      flex: 2;
    }

    .row {
      display: flex;
      margin-bottom: 5px;
      line-height: 32px;

      &:nth-last-child(1) {
        margin: 0;
      }

      span {
        flex: 3;

        &:nth-child(2) {
          flex: 1;
        }
      }
    }
  }
}

.box {
  border-radius: 8px;
  margin: 24px 15px 0;

  .box-title {
    text-align: center;
    margin: 48px 0 24px;
    font-size: 18px;
  }

  h6 {
    font-size: 18px;
    margin-bottom: 10px;
  }

  .box-list {
    padding: 0 40px;
    background-color: #e8e8e8;
    display: flex;
    flex-wrap: wrap;
    border-radius: 8px;

    .item {
      display: flex;
      justify-content: center;
      align-items: center;
      width: 288px;
      border-right: 1px solid #edeff4;
      border-bottom: 1px solid #edeff4;
      padding: 20px 0;

      .item-box {
        display: flex;
        justify-content: center;
        align-items: center;

        /deep/.el-radio__input {
          transform: scale(1.5);
        }

        /deep/ .el-radio__label {
          display: none;
        }

        .el-checkbox {
          margin-right: 20px;
        }

        .item-content {
          padding: 15px;
          border: 1px solid #edeff4;
          border-radius: 4px;
          background-color: #fff;
          width: 178px;
          cursor: pointer;

          .remark {
            margin-bottom: 14px;
          }

          .NO {
            color: #999;
          }
        }
      }
    }
  }
}
</style>